<div class="selected-cell flex-row align-center g-space-sm">
  <cam-font-icon class="selected-icon" [name]="this.selectedIcon" type="sm"></cam-font-icon>
  <span class="flex-1">{{ this.data?.description ?? '' }}</span>
</div>
